<template>
    <div>

        <n-modal-building
                v-if="buildingDetail"
                v-bind:content="{formData: buildingDetail, myError: []}"
        ></n-modal-building>
        <n-bread
                v-bind:content="{bread_list, bread_active}"
        ></n-bread>
        <div class="row"  v-if="buildingDetail">
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-2">
                        <img src="/img/icons/mercatolibero_icon.svg" class="img-fluid">
                    </div>
                    <div class="col-md-10">
                        <div class="card  abtg__default-card abtg__default-card-border">
                            <div class="card-head">
                                <header>{{$t('operation.title_card')}}</header>
                                <div class="abtg__header_popover">
                                    <popover module="custom" content="buildingData" color="grey"
                                             position="right"></popover>
                                </div>

                                <div class="tools" style="margin-bottom: 0 !important;">
                                    <a @click="showModal('m-building')"
                                           class="btn btn-default abtg__btn-star shadow-none abtg__btn-tool">

                                            Modifica

                                    </a>
                                </div>
                            </div>
                            <div class="card-body ">

                                <p><span class="  abtg__text-abtg">{{$t('valutation.label_city')}}:</span> <strong><span
                                        class="abtg__color-black-label">{{buildingDetail.citta}}</span></strong> <br>
                                    <span class="abtg__text-abtg">{{$t('valutation.label_zone')}}:</span> <strong><span
                                            class="abtg__color-black-label">{{DASH_IF_EMPTY(buildingDetail.zone)}}</span></strong>
                                    |
                                    <span class="abtg__text-abtg">{{$t('valutation.label_macrozone')}}:</span>
                                    <strong><span
                                            class="abtg__color-black-label">{{DASH_IF_EMPTY(buildingDetail.macrozone)}}</span></strong>
                                    |
                                    <span class="abtg__text-abtg">{{$t('valutation.label_microzone')}}:</span>
                                    <strong><span
                                            class="abtg__color-black-label">{{DASH_IF_EMPTY(buildingDetail.microzone)}}</span></strong>
                                </p>
                                <hr class="abtg__hr-narrow">
                                <div class="row">
                                    <div class="col-md-8">
                                        <p><span class="abtg__label-small">{{$t('valutation.label_address')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{buildingDetail.via}}</span></strong>
                                        </p>
                                    </div>

                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('operation.overview_label_mq')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{buildingDetail.mq}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('operation.overview_label_value')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{buildingDetail.prezzo}}</span></strong>
                                        </p>
                                    </div>
                                </div>

                                <hr class="abtg__hr-narrow">
                                <div class="row">
                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('valutation.label_room')}}</span><br><strong><span
                                                class="abtg__color-black-label">{{buildingDetail.locali}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span class="abtg__label-small">Piano</span><br><strong><span
                                                class="abtg__color-black-label">{{buildingDetail.piano}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span class="abtg__label-small">{{$t('valutation.label_lift')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{buildingDetail.ascensori}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-2">
                                        <p><span
                                                class="abtg__label-small">{{$t('valutation.label_bathroom')}}</span><br>
                                            <strong><span
                                                    class="abtg__color-black-label">{{buildingDetail.bagni}}</span></strong>
                                        </p>
                                    </div>
                                    <div class="col-lg-4"><p>
                                        <span class="abtg__label-small">{{$t('valutation.label_renovation')}}</span><br>
                                        <strong><span
                                                class="abtg__color-black-label">{{buildingDetail.ristrutturazione}}</span></strong>
                                    </p></div>
                                </div>
                                <hr class="abtg__hr-narrow">
                                <div class="row">
                                    <div class="col-lg-4"><p><span class="abtg__label-small">{{$t('valutation.label_date')}}</span><br><strong><span
                                            class="abtg__color-black-label">{{buildingDetail.data}}</span></strong></p>
                                    </div>
                                    <div class="col-lg-5"><p><span class="abtg__label-small">{{$t('valutation.label_link')}}</span><br>
                                        <strong><a target="_blank"
                                                   :href="buildingDetail.myLink"
                                                   v-if="buildingDetail.myLink"
                                        >
                                            Vai all'annuncio</a></strong></p></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-md-4">
                <div class="row">
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">
                            <div class="card-head ">
                                <div class="abtg__small-card-header"><i class="fas fa-circle"></i> <span
                                        class="abtg__small-card-label">ROI</span></div>
                            </div>
                            <div class="card-body no-padding ">
                                <div class="abtg__card-text-number" v-if="roi_">{{roi_}}%</div>
                                <div class="progress">
                                    <div class="progress-bar" style="width:100%;"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">
                            <div class="card-head ">
                                <div class="abtg__small-card-header"><i class="fas fa-circle"></i> <span
                                        class="abtg__small-card-label">ROE</span></div>
                            </div>
                            <div class="card-body no-padding ">
                                <div class="abtg__card-text-number" v-if="roe_">{{roe_}}%</div>
                                <div class="progress">
                                    <div class="progress-bar" style="width:100%;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="card abtg__default-card abtg__default-card-border">
                            <div class="card-body no-padding ">
                                <p><span class="abtg__label-small">Note</span><br>
                                    <span class="abtg__label-small-text">{{buildingDetail.note}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import NBread from '@/partials/bread';
    import {mapActions, mapState, mapMutations} from 'vuex';
    import {mixin} from '@/helpers/helper'
    import {roles} from '@/helpers/roles';
    import {Money} from 'v-money';
    import NModalBuilding from '@/partials/mapping/modal_building';
    import Popover from '@/partials/popover';



    export default {
        mixins: [mixin, roles],
        components: {Money, Popover, NBread, NModalBuilding},
        props: ['id', 'customId', 'page', 'type'],
        data: function () {
            return {
                roi_: null,
                roe_: null,
            }
        },

        computed: {
            ...mapState('n_mapping', ['bread_active', 'bread_list',
                'buildingDetail'
            ]),

        },

        created: function () {
            this.SET_DATA({name: 'bread_active', data: {label: 'Conto Economico'}});
            this.retrieveMappedBuilding({id: this.$route.params.id});
        },

        methods: {
            ...mapActions('n_mapping', [ 'retrieveMappedBuilding'
            ]),
            ...mapMutations('n_mapping', ['SET_DATA']),

            onSubmit: function () {
                this.$store.dispatch('custom/saveData');
            },

            showHideModal: function () {
                this.$store.dispatch('custom/showHideModal');
            },
            closeOrOpen: function () {
                this.$store.dispatch('custom/closeOrOpen', {
                    resourceId: this.page,
                    type: this.type
                });
            },

            showModal(modalName) {
                this.$modal.show(modalName);
            },
        }
    }
</script>
